import { render, staticRenderFns } from "./assetMng.vue?vue&type=template&id=227e4355&scoped=true"
import script from "./assetMng.vue?vue&type=script&lang=js"
export * from "./assetMng.vue?vue&type=script&lang=js"
import style0 from "./assetMng.vue?vue&type=style&index=0&id=227e4355&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e4355",
  null
  
)

export default component.exports